import Vue from "vue";
import Multiselect from 'vue-multiselect';
import draggable from "vuedraggable";

import columnsMappingBase from "./components/importConfiguration/columnsMappingBase.vue";
import importConfigurationBase from "./components/importConfiguration/importConfigurationBase.vue";
import defaultLayout from "./layouts/default.vue";
import emptyLayout from "./layouts/empty.vue";
import topNavBar from "./components/topNavBar.vue"
import importConfigXML from "./components/importConfiguration/importConfigXML.vue";
import importConfigCSV from "./components/importConfiguration/importConfigCSV.vue";

class main_registraion {
	init = function (): void {
		Vue.component("top-nav-bar", topNavBar);
		Vue.component("default-layout", defaultLayout);
		Vue.component("empty-layout", emptyLayout);
		Vue.component("columns-mapping-base", columnsMappingBase);
		Vue.component("columns-mapping-base", columnsMappingBase);
		Vue.component("import-configuration-base", importConfigurationBase);
		Vue.component("import-config-xml", importConfigXML);
		Vue.component("import-config-csv", importConfigCSV);
		Vue.component("draggable", draggable);
		Vue.component('multiselect', Multiselect)
	};
}

export default new main_registraion();
